<template>
  <div>
    <div class="text-muted small">{{notification.created_at | formatRelativeDate}}</div>

    <!--CREATED-->
    <div>

      <div v-if="notification.data.report === 'article_report'">{{$t('system.your')}}
        <router-link
              :to="{name: 'maintenance.reports', params: { client: notification.data.client.slug }}"
              qid="reports-link"
              v-if="isGranted(permissions.MAINTENANCE_VIEW)"
          >
          {{$t('reports.article_report')}}
        </router-link> {{$t('system.is_generated')}}.
      </div>
      <div v-if="notification.data.report === 'system_report'">
        {{$t('system.your')}} <router-link
              :to="{name: 'maintenance.reports', params: { client: notification.data.client.slug }}"
              qid="reports-link"
              v-if="isGranted(permissions.MAINTENANCE_VIEW)"
      >
        {{$t('reports.system_report')}}
      </router-link> {{$t('system.is_generated')}}.
      </div>
      <div v-if="notification.data.report === 'third_party_report'">
        {{$t('system.your')}} <router-link
              :to="{name: 'maintenance.reports', params: { client: notification.data.client.slug }}"
              qid="reports-link"
              v-if="isGranted(permissions.MAINTENANCE_VIEW)"
      >
        {{$t('reports.third_party_report')}}
      </router-link> {{$t('system.is_generated')}}.
      </div>
      <div v-if="notification.data.report === 'process_risk_report'">
        {{$t('system.your')}} <router-link
              :to="{name: 'maintenance.reports', params: { client: notification.data.client.slug }}"
              qid="reports-link"
              v-if="isGranted(permissions.MAINTENANCE_VIEW)"
      >
        {{$t('reports.process_risk_report')}}
      </router-link> {{$t('system.is_generated')}}.
      </div>

      <div v-if="notification.data.report === 'process_overview_report'">
        {{$t('system.your')}} <router-link
              :to="{name: 'maintenance.reports', params: { client: notification.data.client.slug }}"
              qid="reports-link"
              v-if="isGranted(permissions.MAINTENANCE_VIEW)"
      >
        {{$t('reports.process_overview_report')}}
      </router-link> {{$t('system.is_generated')}}.
      </div>
      <div v-if="notification.data.report === 'risk_control_report'">
        {{$t('system.your')}} <router-link
              :to="{name: 'maintenance.reports', params: { client: notification.data.client.slug }}"
              qid="reports-link"
              v-if="isGranted(permissions.MAINTENANCE_VIEW)"
      >
        {{$t('reports.risk_report')}}
      </router-link> {{$t('system.is_generated')}}.
      </div>
      <div v-if="notification.data.report === 'framework_report'">
        {{$t('system.your')}} <router-link
              :to="{name: 'maintenance.reports', params: { client: notification.data.client.slug }}"
              qid="reports-link"
              v-if="isGranted(permissions.MAINTENANCE_VIEW)"
      >
        {{$t('reports.soa_report')}}
      </router-link> {{$t('system.is_generated')}}.
      </div>
      <div v-if="notification.data.report === 'framework_implementation_report'">
        {{$t('system.your')}} <router-link
              :to="{name: 'maintenance.reports', params: { client: notification.data.client.slug }}"
              qid="reports-link"
              v-if="isGranted(permissions.MAINTENANCE_VIEW)"
      >
        {{$t('reports.framework_implementation_report')}}
      </router-link> {{$t('system.is_generated')}}.
      </div>
    </div>
  </div>
</template>

<script>
  import piincHttp from '@/util/configureAxios.js';
  import UserLink from '@/components/user/Link.vue';
  import Avatar from '@/components/Avatar.vue';

  export default {
    name: 'ReportGeneratedNotification',
    data: function () {
      return {
        activeNavbar: this.$store.state.activeNavbar,
        items: [],
        currentPage: 1,
        totalRows: 0,
      }
    },
    components: {
      UserLink,
      Avatar
    },
    props: {
      notification: {},
      changes: false
    },
    computed: {
      getNavType() {
        return this.$store.state.activeNavbar
      },
      getClient() {
        return this.$store.state.client
      },
    },
    watch: {},
    methods: {
    },
    created() {
    }
  }
</script>

<style scoped lang="scss">

</style>
